import { useCallback } from 'react';

import { useWebsocketSubscription } from 'hooks/useWebsocketSubscription';
import { DenialListImportStatus } from 'services/api/admin/denialListImports';
import { DENIAL_LIST_IMPORT_CHANNEL } from 'services/api/constants';

export type DenialListImportChannelMessage = {
  id: string;
  status: DenialListImportStatus;
  error: string | null;
  filename: string | null;
};

// ActionCable subscribe params bypass OliveBranch (which only runs as Rack middleware for HTTP),
// so the key must be snake_case to match what the Rails channel reads (denial_list_import_id —
// see api/app/channels/application_cable/channel.rb#param_key).
type DenialListImportChannelParams = {
  denial_list_import_id?: string;
};

type UseDenialListImportChannelOptions = {
  params: DenialListImportChannelParams;
  onMessageReceived?: (data: DenialListImportChannelMessage) => void;
};

export default function useDenialListImportChannel({ params, onMessageReceived }: UseDenialListImportChannelOptions) {
  const handleReceived = useCallback(
    (data: DenialListImportChannelMessage) => {
      onMessageReceived?.(data);
    },
    [onMessageReceived]
  );

  const { isConnected } = useWebsocketSubscription<DenialListImportChannelMessage>({
    channel: DENIAL_LIST_IMPORT_CHANNEL,
    params,
    onReceived: handleReceived,
    enabled: !!params.denial_list_import_id,
  });

  return {
    isSubscribed: isConnected,
  };
}
